export const DELETE_CANVAS = 'DELETE_CANVAS';
export const DELETE_CANVAS_START = `${DELETE_CANVAS}_START`;
export const DELETE_CANVAS_SUCCESS = `${DELETE_CANVAS}_SUCCESS`;
export const DELETE_CANVAS_FAIL = `${DELETE_CANVAS}_FAIL`;
export function deleteCanvas({ id }) {
  return {
    type: DELETE_CANVAS,
    meta: {
      xmApi: true,
      uri: `/webapi/xm/1/flow-canvases/${id}`,
      method: 'del',
    },
  };
}

// Used to create or update _just the canvas_, should not include its subresources such as blocks or edges:
export const UPDATE_CANVAS_MINIMAL = 'UPDATE_CANVAS_MINIMAL';
export const UPDATE_CANVAS_MINIMAL_START = `${UPDATE_CANVAS_MINIMAL}_START`;
export const UPDATE_CANVAS_MINIMAL_SUCCESS = `${UPDATE_CANVAS_MINIMAL}_SUCCESS`;
export const UPDATE_CANVAS_MINIMAL_FAIL = `${UPDATE_CANVAS_MINIMAL}_FAIL`;
export const updateCanvasMinimal = ({ canvas }) => ({
  type: UPDATE_CANVAS_MINIMAL,
  meta: {
    xmApi: true,
    method: 'put',
    uri: '/webapi/xm/1/flow-canvases',
    params: {
      id: canvas.id,
      plan: canvas.plan,
      form: canvas.form,
      name: canvas.name,
      description: canvas.description,
    },
  },
});
